import React, { useState, useEffect } from 'react';

import parse from 'html-react-parser';


import Hosts from '../../Hosts'
import {
	reqGET,
    set_language,
	content_language, 

} from '../../Utils';

const TermsConditions = () => {

    const [data, setData] = useState([]);

    const [lang, set_lang] = useState('pt');
    const [lang_id, set_lang_id] = useState('1');
    

    let getInfo = async () => {

        reqGET(`${Hosts.SIMCore_API}/web/content/slug/${Hosts.companycode}/terms-conditions`)
            .then(res => { 
                setData(res.data)

            })
            .catch(erro => alert('Erro'))  

    }   
    
    useEffect(() => { 
        getInfo()

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

    }, []);

    return (
      
        <div className={`dash-cards-2 body`}>
            <div className="card">
                {data.map((v, key) => { 
                    return (            
                        <div className="card-body ck-webcontent" key={key}>
                            { 
                            (v.content.title !== '' || (v.content.language !== undefined && v.content.language[lang_id] !== undefined && v.content.language[lang_id] !== null && v.content.language[lang_id].title !== undefined && v.content.language[lang_id].title !== '')) ? 
                                <h2 className="dash-title">
                                    {
                                    lang === 'pt' || v.content.language === undefined ? 
                                        v.content.title 
                                    : 
                                        (
                                        v.content.language[lang_id] !== undefined && v.content.language[lang_id]['title'] !== undefined && v.content.language[lang_id]['title'] !== '' ? 
                                            v.content.language[lang_id].title
                                        :
                                            v.content.title 
                                        )
                                    }
                                </h2>
                            : 
                                null 
                            } 
                            <div className="div-break"></div>
                            { (v.content.abstract !== '' || (v.content.language !== undefined && v.content.language[lang_id] !== undefined && v.content.language[lang_id] !== null && v.content.language[lang_id].abstract !== undefined && v.content.language[lang_id].abstract !== '')) ? ( 
                                <div className="div-group">
                                    <span className="flex-1">
                                    {parse(lang === 'pt' || v.content.language === undefined ? v.content.abstract : (v.content.language[lang_id] === undefined || v.content.language[lang_id]['abstract'] === undefined || v.content.language[lang_id].abstract === '' ? v.content.abstract : v.content.language[lang_id].abstract))}
                                    </span>
                                </div>
                            ) : null }
                            { v.content.content_files.length > 0 || (v.content.language !== undefined && v.content.language[lang_id] !== undefined && v.content.language[lang_id] !== null && v.content.language[lang_id]['content_files'] !== undefined && v.content.language[lang_id]['content_files'] !== null) ? (
                                <>
                                    <div className="div-break"></div>
                                    {
                                    lang === 'pt' || v.content.language === undefined ?
                                        <div className="div-group">
                                            <span className="flex-1">
                                                {
                                                v.content['content_files'] !== undefined ? 
                                                    v.content.content_files.map((value, key) => {
                                                        return (
                                                            <div key={key} className="assec-d-flex">
                                                                <img className="" style={{height: '20px'}} alt='pdf' src={'./img/pdf.svg'} />
                                                                <a className="assec-ml-5" href={value.path + value.source_name} download={value.name} target="_blank" rel="noreferrer">
                                                                    {/*{language[lang].submission_rules_pdf}*/}
                                                                    { (v.content.title !== '' || (v.content.language !== undefined && v.content.language[lang_id].title !== undefined && v.content.language[lang_id].title !== '')) ? ( 
                                                                        
                                                                        lang === 'pt' || v.content.language === undefined ? v.content.title : (v.content.language[lang_id] === undefined || v.content.language[lang_id]['title'] === undefined || v.content.language[lang_id].title === '' ? v.content.title : v.content.language[lang_id].title)
                                                                    
                                                                    ) : null } 
                                                                </a>
                                                            </div>
                                                        )
                                                    })
                                                : ''
                                                }
                                            </span>
                                        </div> 
                                    : 
                                        <div className="div-group" style={{display: 'contents'}}>
                                            { v.content.language !== undefined && v.content.language[lang_id] !== undefined && v.content.language[lang_id].content_files.length > 0 ? (
                                                <span className="flex-1">
                                                    {
                                                    v.content.language[lang_id]['content_files'] !== undefined && v.content.language[lang_id]['content_files'] !== null ? 
                                                        v.content.language[lang_id].content_files.map((value, key) => {
                                                            return (
                                                                <div key={key} className="assec-d-flex">
                                                                    
                                                                    <img className="" style={{height: '20px'}} alt='pdf' src={'./img/pdf.svg'} />
                                                                    <a className="assec-ml-5" href={value.path + value.source_name} download={value.name} target="_blank" rel="noreferrer">
                                                                        {/*{language[lang].submission_rules_pdf}*/}
                                                                        { (v.content.title !== '' || (v.content.language !== undefined && v.content.language[lang_id].title !== undefined && v.content.language[lang_id].title !== '')) ? ( 
                                                                            
                                                                            lang === 'pt' || v.content.language === undefined ? v.content.title : (v.content.language[lang_id].title === '' ? v.content.title :v.content.language[lang_id].title)
                                                                        
                                                                        ) : null }
                                                                        
                                                                    </a>
                                                                    
                                                                </div>
                                                            )
                                                        })
                                                    : ''
                                                    }
                                                    <p className="dash-p-title"></p>
                                                </span>
                                            ) : null }
                                        </div> 
                                    }
                                </>                    
                            ) : null }
                            
                            { (v.content.text !== '' || (v.content.language !== undefined && v.content.language[lang_id] !== undefined && v.content.language[lang_id] !== null && v.content.language[lang_id].text !== undefined && v.content.language[lang_id].text !== '')) ? (
                                <div className="div-group">
                                    <span className="flex-1">
                                    {parse(lang === 'pt' || v.content.language === undefined ? v.content.text : (v.content.language[lang_id] === undefined ||v.content.language[lang_id]['text'] === undefined || v.content.language[lang_id].text === '' ? v.content.text : v.content.language[lang_id].text))}
                                    </span>
                                </div>
                            ) : null }                
                        </div>
                    )
                })
                }
            </div>
        </div>
     
    );

};
export default TermsConditions;

